<template>
    <BaseButton
        class="font-bold uppercase bg-brand-green hover:bg-brand-green-dark"
        :href="href"
    >
        {{ text }} <i class="ml-4 fa-lg fas fa-angle-right"></i>
    </BaseButton>
</template>

<script>
import BaseButton from './BaseButton.vue';

export default {
    components: {
        BaseButton,
    },
    props: {
        text: {
            type: String,
            required: true
        },
        href: {
            type: String,
            default: null,
        }
    }
}
</script>
